/**
 * @author mrdoob / http://mrdoob.com/
 */

let _context;
const AudioContext = {
  getContext: function () {
    if (_context === undefined) {
      _context = new (window.AudioContext || window.webkitAudioContext)();
    }
    return _context;
  },
  setContext: function (value) {
    _context = value;
  }
};
export { AudioContext };